<form (ngSubmit)="next()" [formGroup]="form" class="m-t-30 animate__animated animate__fadeIn">

	<app-kamona-input-field
		[input]="username">
	</app-kamona-input-field>

	<div class="m-t-30" nz-row nzAlign="middle" nzJustify="space-between">
		<div>
		</div>
		<div nz-row nzAlign="middle">
			<div>
				<div [routerLink]="'/login'" class="back-btn">
					Go back to Login
				</div>
			</div>
			<div>
				<div class="m-l-32">
					<div class="button-size-102">
						<app-kamona-custom-button
							[isBlock]="true"
							[isSubmitting]="submittingForm"
							text="Next">
						</app-kamona-custom-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>
